import React from 'react';
export function Footer() {
  return <footer className="py-12 px-4 border-t border-white/10 bg-black text-center text-gray-500 text-sm font-medium" data-id="element-100">
      <div className="max-w-4xl mx-auto space-y-4" data-id="element-101">
        <p className="text-gray-400 font-bold" data-id="element-102">
          Kit Completo Programmazione™ — Il sistema N.1 per docenti
          professionali di Informatica negli Istituti Tecnici e Professionali
          italiani.
        </p>
        <p data-id="element-103">
          <a href="mailto:kitonline27@gmail.com" className="hover:text-brand-orange transition-colors" data-id="element-104">
            📧 kitonline27@gmail.com
          </a>
        </p>
        <p data-id="element-105">
          © Kit Completo Programmazione™ 2026 — Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}